import styles from './WorkTypeSummary.less';

import React from 'react';
import PropTypes from 'prop-types';
import { filter, size } from 'lodash';

export default class WorkTypeSummary extends React.Component {
  static propTypes = {
    workTypes: PropTypes.array.isRequired
  };

  render() {
    const selectedWorkTypes = filter(this.props.workTypes, 'isActive');
    const total = size(this.props.workTypes);
    const count = size(selectedWorkTypes);

    return (
      <span
        className={`${styles.root} ${
          count === 1 ? styles.root_hasOneSelected : ''
        }`}
      >
        <span className={styles.count}>
          <span>{count === 0 || count === total ? 'All' : count} </span>
          <span className={styles.work}>work </span>
          <span>type{count !== 1 && 's'}</span>
        </span>

        {count > 0 && (
          <span>
            <span className={styles.colon}>: </span>
            {selectedWorkTypes.map((type, i) => {
              return (
                <span key={i} className={styles.workType}>
                  {i > 0 && ', '}
                  {type.label.split('/')[0]}
                </span>
              );
            })}
          </span>
        )}
      </span>
    );
  }
}
